// Layout/preferences for the AI assistant panel, persisted per-device.
// Width is remembered across sessions so the admin's resize sticks.

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const AI_PANEL_MIN_WIDTH = 360;
export const AI_PANEL_MAX_WIDTH = 960;
const AI_PANEL_DEFAULT_WIDTH = 460;

function clampWidth(w: number): number {
  return Math.max(AI_PANEL_MIN_WIDTH, Math.min(AI_PANEL_MAX_WIDTH, Math.round(w)));
}

interface AiPanelState {
  /** Drawer / panel width in px (clamped to [min, max]). */
  panelWidth: number;
  setPanelWidth: (w: number) => void;
  /** Whether the history pane is expanded. */
  historyOpen: boolean;
  setHistoryOpen: (open: boolean) => void;
}

export const useAiPanelStore = create<AiPanelState>()(
  persist(
    (set) => ({
      panelWidth: AI_PANEL_DEFAULT_WIDTH,
      setPanelWidth: (w) => set({ panelWidth: clampWidth(w) }),
      historyOpen: false,
      setHistoryOpen: (historyOpen) => set({ historyOpen }),
    }),
    { name: 'ai_panel_layout' },
  ),
);
